import { ActionCardData, sectionTypes } from '@playbooks/action-cards-utils/src'

export default function lockVisibleHeaders(card: ActionCardData, headers: number | null) {
  let headersIndex = 0
  card.sections.forEach(sec => {
    if (sec.type === sectionTypes.SEPARATOR) {
      if (!headers || headersIndex < headers) {
        sec.isLocked = true
      }
      headersIndex++
    }
  })
}
